exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-proof .ant-upload{width:100%}.form-proof .ant-upload.ant-upload-select-picture-card{width:100%;height:auto;border:#ffdead;background:rgba(0,0,0,0);margin:0;border-radius:0;display:flex}@media screen and (max-width: 800px){.form-proof .ant-upload.ant-upload-select-picture-card .ant-upload{width:100%}}", ""]);

